module.exports = __webpack_public_path__ + "img/CS-Small_Overview-Front_1.dfb22936.jpg";